import React from 'react';
import styles from './WorkingMode.module.scss'
import Tooltip from "../Tooltip/Tooltip";
import {$t} from "../../../helpers/translator";

const WorkingMode = (props) => {

    const modes = {
        '1': {
            text: 'A',
            color: '#333333',
            explain: $t('global.workingModes.1')
        },
        '2': {
            text: 'S',
            color: '#444',
            explain: $t('global.workingModes.2')
        },
        '3': {
            text: 'P',
            color: '#111111',
            explain: $t('global.workingModes.3')
        },
        '4': {
            text: 'F',
            color: '#222',
            explain: $t('global.workingModes.4')
        },
        '?' : {
            text: '?',
            color: '#222',
            explain: $t('global.workingModes.notDefined')
        }
    }

    return (
        <div className={styles.container}>
            {props.mode ?
                <Tooltip content={modes[props.mode].explain} key={modes[props.mode].text}>
                    <div className={`${styles.circle} ${styles[modes[props.mode].text]}`}>
                        <div className={styles.text}>
                            {modes[props.mode].text}
                        </div>
                    </div>
                </Tooltip>
            :
            'mode undefined'
            }

        </div>
    );
}

WorkingMode.defaultProps = {
    mode: '?',
}


export default WorkingMode;
